import { useCallback, useRef, useState } from "react";
import { loadKnockTarget } from "../../lib/draft";
import { continueWithX } from "../../lib/session";
import { useShell } from "../../lib/shell";
import { SignIn } from "./sign-in";

/**
 * The sign-in screen, wired up.
 *
 * It exists in two places on purpose. `/` is the obvious one; the other is a
 * door — arriving at `nob.me/@handle` signed out used to bounce the sender to
 * `/`, which threw away the one thing the visit was about. The address stays,
 * the stored knock target covers the round-trip out to the provider and back,
 * and the sender lands where they were going.
 */
export function SignInScreen({ error }: { error?: string | null }) {
  const { notice } = useShell();
  const [own, setOwn] = useState<string | null>(null);
  /**
   * Which run this is, and therefore how many dots (FR-1.1). A held knock
   * target means the visit started at somebody else's door, so the run is two
   * steps and the counter must say so — read once, on the first render, because
   * it is a fact about how this visit began and not something that changes
   * while the screen is up.
   */
  const knocker = useRef(loadKnockTarget() !== null);

  const goToX = useCallback((as?: string) => {
    setOwn(null);
    void continueWithX(as).then((message) => {
      if (message) setOwn(message);
    });
  }, []);

  return (
    <SignIn onContinueWithX={goToX} error={own ?? error ?? notice} knocker={knocker.current} />
  );
}
